import React from 'react';

import AppLayout from '../../components/AppLayout';
import { useUser } from '../../hooks/useUser';

import DatevRulesets from './components/DatevRulesets';
import LexOfficeRulesets from './components/LexOfficeRulesets';

const BookingRulesetPage: React.FC = () => {
  const { user, loading: userLoading } = useUser();
  const bookingSystem = user?.bookingSystem ?? 'datev';

  return (
    <AppLayout>
      <div className='p-6'>
        <div className='max-w-4xl mx-auto'>
          <h1 className='text-3xl font-bold mb-2 text-gray-900 dark:text-white'>
            Booking Rulesets
          </h1>
          <p className='text-gray-600 dark:text-gray-400 mb-6'>
            Add custom booking rules to reflect how your business categorizes
            invoices. These rules guide the AI and significantly improve the
            accuracy of generated bookings.
          </p>

          <div className='space-y-6'>
            {userLoading ? (
              <div className='bg-white dark:bg-gray-800 rounded-lg shadow-md p-6'>
                <div className='animate-pulse'>
                  <div className='h-6 bg-gray-200 dark:bg-gray-700 rounded w-1/3 mb-4'></div>
                  <div className='h-20 bg-gray-200 dark:bg-gray-700 rounded mb-2'></div>
                </div>
              </div>
            ) : bookingSystem === 'lexoffice' ? (
              <LexOfficeRulesets />
            ) : (
              <DatevRulesets />
            )}
          </div>
        </div>
      </div>
    </AppLayout>
  );
};

export default BookingRulesetPage;
